import microuniversoApi from "app/api/microuniversoApi"
import { sobrescreverInformacoesAction } from "app/redux/orcamentoSlice"
import store from "app/redux/store/store"
import * as atualizacaoItensOrcamentoLegadoActions from 'app/redux/atualizacaoItensOrcamentoLegadoSlice'
import * as atualizacaoOrcamentoLegadoActions from 'app/redux/atualizacaoOrcamentoLegadoSlice'

import globalMU from "globalMU"

declare var window:any

export type DefinirTipoFaturamentoItemParams = {
    identificadorItem: number,
    tipoFaturamento: string,
    atualizarEstadoLegadoImediatamente?: boolean
    itemLegado?:any
}

export async function definirTipoFaturamentoItem(params: DefinirTipoFaturamentoItemParams) {
    try {
        globalMU.blockUI({tryPassiveLoading: true})

        const orcamentoAtualizado = await microuniversoApi.Orcamento.definirTipoFaturamentoItem(
            params.identificadorItem,
            store.getState().orcamento.IdentificadorOrcamento,
            params.tipoFaturamento
        )
    
        

        const obterItemOrcamentoLegado = () => params?.itemLegado ?? window.orcamentoController.model.get("ItensOrcamento").find(i => i.get("Identificador") == params.identificadorItem) 

        const atualizarOrcamentoLegado = () => {
            const orcamentoLegado = window.orcamentoController.model
            const itemAtualizado = orcamentoAtualizado.ItensOrcamento.find(i => i.Identificador == params.identificadorItem)

            if (!params.atualizarEstadoLegadoImediatamente) {
                store.dispatch(atualizacaoItensOrcamentoLegadoActions.atualizarItem({
                    identificador: itemAtualizado.Identificador,
                    dadosItem: itemAtualizado
                }))
            } else {
                obterItemOrcamentoLegado()?.atualizar?.(itemAtualizado, true, true, true)
            }
    
            orcamentoLegado.atualizar(
                orcamentoAtualizado, 
                params.atualizarEstadoLegadoImediatamente == true, 
                true)

            
            if (!params.atualizarEstadoLegadoImediatamente) {
                store.dispatch(atualizacaoOrcamentoLegadoActions.atualizar(orcamentoAtualizado))
            }
        }
    
        
        atualizarOrcamentoLegado()
    } finally {
        globalMU.unblockUI()
    }

    
}